import { useEffect, useState } from 'react';
import moment from 'moment';
import { TCalendarInputPiece } from '@/components/DateRangeInput';
import useHomeContext from '@/hooks/useHomeContext';
import { dateWithoutTime } from '@/utils/dates';

export const LAST_7_DAYS = 'Last 7 days';
const LAST_MONTH = 'Last Month';
const LAST_90_DAYS = 'Last 90 days';
const YEAR_TO_DATE = 'Year to date';

const generateOption = (option: string) => ({
  label: option,
  value: option
});

export type TDateOption = {
  label: string;
  value: string | undefined;
};

export const dateOptions = [
  { label: 'Custom view', value: undefined },
  generateOption(LAST_7_DAYS),
  generateOption(LAST_MONTH),
  generateOption(LAST_90_DAYS),
  generateOption(YEAR_TO_DATE)
];

export const useDateFilter = () => {
  const { setDateFilter, dateFilter } = useHomeContext()!;
  const defaults = {
    today: new Date(),
    dateRange: dateOptions[1]
  };

  const sevenDaysAgo = moment(defaults.today).subtract(7, 'days').startOf('day').toDate();

  const [rangeName, setRangeName] = useState(defaults.dateRange);
  const [startDate, setStartDate] = useState<TCalendarInputPiece>(sevenDaysAgo);
  const [endDate, setEndDate] = useState<TCalendarInputPiece>(
    moment(defaults.today).endOf('day').toDate()
  );

  useEffect(() => {
    if (dateFilter?.startDate && dateFilter?.endDate && dateFilter?.rangeName) {
      setStartOfRange(dateWithoutTime(dateFilter.startDate));
      setEndOfRange(dateWithoutTime(dateFilter.endDate));
      setRangeName(dateFilter.rangeName);
    } else {
      setDateFilter({ startDate, endDate, rangeName });
    }
  }, [dateFilter]);

  const resetDateDefault = () => {
    setRangeName(defaults.dateRange);
    setStartOfRange(sevenDaysAgo);
    setEndOfRange(defaults.today);

    setDateFilter({
      startDate: moment(sevenDaysAgo).startOf('day').toDate(),
      endDate: moment(defaults.today).endOf('day').toDate(),
      rangeName: defaults.dateRange
    });
  };

  const setStartOfRange = (date: TCalendarInputPiece) => {
    if (!date) return;
    setStartDate(dateWithoutTime(date));
  };
  const setEndOfRange = (date: TCalendarInputPiece) => {
    if (!date) return;
    setEndDate(dateWithoutTime(date));
  };

  return {
    rangeName,
    setRangeName,
    startDate,
    setStartOfRange,
    endDate,
    setEndOfRange,
    resetDateDefault
  };
};
